<template>
  <div class="home h-100 bg-grey-lighten-5 ">
    <v-container fluid scroll-behavior="elevate" class="d-flex justify-space-between ma-0 px-sm-25 pt-2 pb-4 pb bg-indigo-darken-3">
      <v-container fluid class="w-auto ml-0 d-flex align-center">
        <img class="w-70px w-sm-100px" src="@/assets/images/wug-torino-2025.svg" >
        <img class="w-70px w-sm-100px" src="@/assets/images/3bmeteo.svg" >
      </v-container>

      <v-container fluid class="w-auto mr-0 d-flex">
        <v-menu location="bottom" :close-on-content-click="false">
          <template v-slot:activator="{ props, isActive }">
            <v-chip v-bind="props" class="bg-grey-lighten-3 h-auto pl-0 my-auto">
              <v-container class="rounded-lg bg-blue-darken-4 rounded-circle pa-3 mr-2 user-select-none">{{ getUserInitialsFromUser(user) }}</v-container>
              <v-icon icon="mdi-chevron-down" :class="[ isActive ? 'rotate-180' : '' ]"></v-icon>
            </v-chip>
          </template>

          <v-list class="bg-white pa-4 rounded-lg">
            <v-container class="d-flex">
              <v-col class="h-100 rounded-lg bg-blue-darken-4 rounded-circle pa-3 mr-2 my-auto flex-0-0-0 user-select-none">{{ getUserInitialsFromUser(user) }}</v-col>
              <v-col class="pa-0">
                <v-container class="text-body-1 text-weight-medium pa-0">{{ user?.name }} {{ user?.surname }}</v-container>
                <v-container class="text-caption pa-0">{{ user?.email }}</v-container>
              </v-col>
            </v-container>

            <v-divider thickness="1" />
            <v-btn variant="text" @click="logout" class="w-100 h-auto mt-3">
              <v-container class="px-0 py-2 w-100 text-start">{{ $t('home.menu.logout') }}</v-container>
            </v-btn>

          </v-list>
        </v-menu>
      </v-container>
    </v-container>

    <bollettini v-if="!bollettini.loading" :bollettini="bollettini.data" />
    <loader v-if="bollettini.loading" />
    <previsione :loading="previsioni.loading" :previsioni="previsioni.data" :localita-tabs="localitaTabsList" @localita-changed="(data) => getMeteoLocalita(data.localitaId)" />

    <v-container class="bg-white mt-7 d-flex justify-space-between mb-10 flex-column flex-sm-row">
      <v-container class="w-auto ma-0">
        <v-container class="pa-0 ma-0 d-block d-sm-inline-block w-auto">{{ $t('home.footer.call') }}</v-container>
        <v-container class="pa-0 ma-0 ml-2 d-block d-sm-inline-block w-auto"><v-icon size="18" icon="mdi-phone-outline" class="pa-0 mr-2" />{{ $t('home.footer.supportPhoneNumber') }}</v-container>
      </v-container>
      <v-container class="w-auto ma-0">
        <v-container class="pa-0 ma-0 d-block d-sm-inline-block w-auto">{{ $t('home.footer.write') }}</v-container>
        <v-container class="pa-0 ma-0 ml-2 d-block d-sm-inline-block w-auto"><v-icon size="18" icon="mdi-email-outline" class="pa-0 mr-2" />{{ $t('home.footer.supportEmail') }}</v-container>

      </v-container>
    </v-container>

    <v-snackbar
      v-model="snackbar.opened"
      :timeout="3000"
    >
      {{ $t(`snackbar.${ snackbar.message }`) }}
    </v-snackbar>

  </div>
</template>

<script lang="ts">
import Bollettini from '@/components/home/Bollettini.vue';
import Previsione from '@/components/home/Previsione.vue';
import { BollettiniResponse, BollettinoGiorno, MeteoLocalitaResponse, PrevisioneGiorno } from '@/modules/api';
import { HttpService } from '@/services/httpService';
import { store } from '@/store';
import { getUserInitialsFromUser, shoudlSwitchDay } from '@/utils/utils';
import { isAxiosError } from 'axios';
import { defineComponent } from 'vue';
import { localitaTabsList } from '@/utils/constants';
import { LocalitaTab } from '@/modules/localitaTab';
import { User } from '@/modules/user';
import Loader from '@/components/Loader.vue';

export default defineComponent({
  name: 'Home',
  components: {
    Bollettini, Previsione, Loader
  },
  data(): HomeDataInterface {
    return {
      localitaTabsList,
      user: undefined,
      bollettini: {
        loading: false,
        data: []
      },
      previsioni: {
        loading: false,
        data: []
      },
      snackbar: {
        opened: false,
        message: undefined
      }
    }
  },
  async mounted() {
    this.user = store.getters.currentUser;
    await this.getBollettini();
  },
  methods: {
    async getBollettini() {
      this.bollettini.loading = true;

      const httpService = HttpService.instance;

      try {
        const response = await httpService.get({ url: "/universiadi/bollettini" });
        const body: BollettiniResponse = response.data;
        if (!shoudlSwitchDay()) {
          this.bollettini.data = body.data.previsione_giorno.slice(0, 2);
        } else {
          this.bollettini.data = body.data.previsione_giorno.slice(1, 3);
        }
      } catch (error) {
        this.handleError(error);
      }

      this.bollettini.loading = false;
    },
    async getMeteoLocalita(idLocalita: number) {
      this.previsioni.loading = true;

      const httpService = HttpService.instance;

      try {
        const response = await httpService.get({ url: `/universiadi/meteoLocalita/${idLocalita}` });
        const body: MeteoLocalitaResponse = response.data;
        if (!shoudlSwitchDay()) {
          this.previsioni.data = body.data.localita.previsione_giorno.slice(0, 2);
        } else {
          this.previsioni.data = body.data.localita.previsione_giorno.slice(1, 3);
        }
      } catch (error) {
        this.handleError(error);
      }

      this.previsioni.loading = false;
    },
    handleError(error: any) {
      if (isAxiosError(error)) {
        if (error.status == 401) {
          console.log(error);
          return;
        }
        this.snackbar.message = error.response?.data.message;
      } else {
        this.snackbar.message = "generic-error";
      }

      this.snackbar.opened = true;
    },
    getUserInitialsFromUser,
    logout() {
      store.dispatch("logout")
    },
  }
});



interface HomeDataInterface {
  localitaTabsList: LocalitaTab[],
  user?: User,
  bollettini: {
    loading: boolean,
    data: BollettinoGiorno[],
  },
  previsioni: {
    loading: boolean,
    data: PrevisioneGiorno[],
  }
  snackbar: {
    opened: boolean;
    message: string | undefined;
  }
}
</script>
